import { defer, type LoaderFunctionArgs } from "react-router-dom";
import { resolveLoaderResult } from "@/routes/loaderResult";
import { getEventsInfo } from "./common/services";

export function eventDetailsLoader({ request }: LoaderFunctionArgs) {
  const activityType = Number(new URL(request.url).searchParams.get("activityType") || "");
  return defer({
    coreData: resolveLoaderResult(getEventsInfo({ activityType })),
  });
}
